/* eslint-disable default-param-last */
import firebase from "src/Firebase"
import { arrayUnion, arrayRemove } from "firebase/firestore"
import moment from "moment"
import axios from "axios"
import { trackContifico } from "src/services/contifico"

const db = firebase.firestore()
const storage = firebase.storage()

export const getUsuarios = (idConjunto, observer) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", idConjunto)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer)
export const updateUsuario = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    Familia: data,
  })

export const ListaResidentes = (idConjunto, Cedula) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", idConjunto)
    .where("Cedula", "==", Cedula)
    .limit(1)
    .get()

export const updateVisitaAnticipada = path =>
  db.doc(path).update({
    EstadoSalida: true,
  })

export const getVisitaAnticipadaWithAditionals = async (
  conjuntoID,
  aditionals = [],
  Cedula
) => {
  const endDay = moment().endOf("day").toDate()
  const startDay = moment().startOf("day").toDate()
  const visitasColl = id =>
    db
      .collection("conjuntos")
      .doc(id)
      .collection("visitasAnticipadas")
      .where("Cedula", "==", Cedula)
      .orderBy("HoraEstimadaLlegada")
      .where("HoraEstimadaLlegada", "<=", endDay)
      .where("HoraEstimadaLlegada", ">=", startDay)
      .limit(1)
  const relacionados = aditionals.filter(id => id !== conjuntoID)
  relacionados.push(conjuntoID)
  const results = await Promise.all(
    relacionados.map(id => visitasColl(id).get())
  )
  const data = []
  results.forEach(res => {
    data.push(...res.docs)
  })
  return data
}

export const getUsuariosByConjunto = (
  conjuntoID,
  aditionals = [],
  observer
) => {
  const relacionados = aditionals.filter(id => id !== conjuntoID)
  relacionados.push(conjuntoID)
  return db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "in", relacionados)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer)
}

export const ListaBlancaNega = async (idConjunto, Cedula) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("lista")
    .where("Cedula", "==", Cedula)
    .limit(1)
    .get()

export const getUser = usuario => db.collection("usuarios").doc(usuario).get()

export const getListaWithAditionals = async (
  idConjunto,
  aditionals = [],
  Cedula
) => {
  const listaRef = id =>
    db
      .collection("conjuntos")
      .doc(id)
      .collection("lista")
      .where("Cedula", "==", Cedula)
      .limit(1)
  const relacionados = aditionals.filter(id => id !== idConjunto)
  relacionados.push(idConjunto)
  const results = await Promise.all(relacionados.map(id => listaRef(id).get()))
  const data = []
  results.forEach(res => {
    data.push(...res.docs)
  })
  return data
}

export const getUnidadesHabWithAditionals = async (
  conjuntoID,
  aditionals = []
) => {
  const unitsRef = id =>
    db.collection("conjuntos").doc(id).collection("unidadesHabitacionales")
  const relacionados = aditionals.filter(id => id !== conjuntoID)
  relacionados.push(conjuntoID)
  const results = await Promise.all(relacionados.map(id => unitsRef(id).get()))
  const data = []
  results.forEach(res => {
    data.push(...res.docs)
  })
  return data
}

export const getUsuario = (observer, idUser) =>
  db.collection("usuarios").doc(idUser).onSnapshot(observer)
export const getModulos = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .onSnapshot(observer)
export const TiposVisita = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("TiposVisita")
    .onSnapshot(observer)

export const getParkey = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .onSnapshot(observer)

export const updateParkey = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .update(data)

export const newIngreso = (Conjunto, data) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("ingresos")
    .add(data)
    .then(trackContifico(Conjunto, "ingreso"))
export const getConjuntoComprobante = (observer, Conjunto) =>
  db.collection("conjuntos").doc(Conjunto).onSnapshot(observer)

export const updateComprobanteTransaccion = (conjuntoUid, data) =>
  db.collection("conjuntos").doc(conjuntoUid).update({
    NumeroComprobante: data,
  })

export const getRubros = (observer, conjuntoUid, tipo) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("rubros")
    .where("Tipo", "==", tipo)
    .onSnapshot(observer)
export const updateIngresoCobros = (conjuntoId, ingresoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("ingresos")
    .doc(ingresoId)
    .update({
      Cobros: data,
    })
    .then(trackContifico(conjuntoId, "ingreso", ingresoId))

// Facturación

export const saveLogoFile = async (file, conjunto) => {
  try {
    const snapshot = await storage
      .ref(`${conjunto}/billLogo/${file.name}`)
      .put(file)
    const url = await snapshot.ref.getDownloadURL()
    if (url) {
      db.collection("conjuntos")
        .doc(conjunto)
        .collection("conjuntoConfig")
        .doc("assets")
        .set({ billLogo: arrayUnion(url) })
    }
    return url
  } catch (error) {
    throw Error("One failed:", file, error.message)
  }
}

export const getLogoFile = (id, onResponse, onError) =>
  db
    .collection("conjuntos")
    .doc(id)
    .collection("conjuntoConfig")
    .doc("assets")
    .onSnapshot(onResponse, onError)

export const deleteLogoFile = async (file, conjunto) => {
  try {
    const refFromUrl = decodeURIComponent(file.split("/").pop().split("?")[0])
    await storage.ref(refFromUrl).delete()
    const bannerRef = db
      .collection("conjuntos")
      .doc(conjunto.id)
      .collection("conjuntoConfig")
      .doc("assets")
    bannerRef.update({
      billLogo: arrayRemove(file),
    })
    return 1
  } catch (error) {
    throw Error("Delete failed:", file, error.message)
  }
}

export const signAndSendSRI = async (idConjunto, json) => {
  try {
    const API_URL = process.env.REACT_APP_BILLING_API
    const response = await axios.post(
      `${API_URL}api/invoices/signSRI/${idConjunto}/`,
      json,
      {
        baseURL: API_URL,
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(`Error: ${error.message}`)
  }
}

export const updateSequenceFacturacion = (idConjunto, newSequence) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Facturacion")
    .update({ numSeq: newSequence })

// Configuración de datos empresa.

export const createConfigFacturacion = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Facturacion")
    .set(data)

export const getConfigFacturacion = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Facturacion")
    .onSnapshot(observer)

export const updateConfigFacturacion = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Facturacion")
    .update(data)

export const updateConjunto = (idConjunto, data) =>
  db.collection("conjuntos").doc(idConjunto).update({
    Ruc: data.ruc,
    Direccion: data.direccion_matriz,
    TelefonoContacto: data.phones,
    CorreoContacto: data.correo,
  })

// Head, body y footer factura

export const addInvoice = (idConjunto, data) =>
  db.collection("conjuntos").doc(idConjunto).collection("facturacion").add(data)

// Cliente en la base

export const addClient = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("clientesFacturacion")
    .add(data)

export const findClientByRuc = async (idConjunto, ruc) => {
  const querySnapshot = await db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("clientesFacturacion")
    .where("Identificacion", "==", ruc)
    .limit(1)
    .get()

  if (!querySnapshot.empty) {
    const doc = querySnapshot.docs[0]
    return { id: doc.id, data: doc.data() }
  }
  return null
}

export const addAuthorizedResident = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .add(data)

export const getAuthorizedResidents = async conjuntoId => {
  const authorizedCollection = await db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .get()

  const authorizedList = authorizedCollection.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }))

  return authorizedList
}

// Función para actualizar un residente autorizado
export const updateAuthorizedResident = (conjuntoId, residentId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .doc(residentId)
    .update(data)

// Función para eliminar un residente autorizado
export const deleteAuthorizedResident = (conjuntoId, residentId) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .doc(residentId)
    .delete()
